import React, { useEffect, useState } from 'react';
import {
    Row,
    Col,
    Table,
    Input,
    Button,
    Divider,
    message,
    Form,
    Card,
    Popconfirm
} from 'antd';
import axios from 'axios';

const HotelAgentManagement = () => {
    const [hotels, setHotels] = useState([]);
    const [agents, setAgents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hotelForm] = Form.useForm();
    const [agentForm] = Form.useForm();

    const fetchData = async () => {
        setLoading(true);
        try {
            const [hotelRes, agentRes] = await Promise.all([
                axios.get('https://api.srilankaballooning.com/api/getHotels'),
                axios.get('https://api.srilankaballooning.com/api/getAgents')
            ]);
            if (hotelRes.data.success) setHotels(hotelRes.data.result);
            if (agentRes.data.success) setAgents(agentRes.data.result);
        } catch (error) {
            message.error('Failed to load data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleAddHotels = async (values) => {
        const names = values.hotel_names.split(',').map(h => h.trim()).filter(h => h);
        try {
            for (let name of names) {
                await axios.post('https://api.srilankaballooning.com/api/addHotel', { HOTEL_NAME: name });
            }
            message.success('Hotel(s) added');
            hotelForm.resetFields();
            fetchData();
        } catch (error) {
            message.error('Failed to add hotel(s)');
        }
    };

    const handleAddAgents = async (values) => {
        const names = values.agent_names.split(',').map(a => a.trim()).filter(a => a);
        try {
            for (let name of names) {
                await axios.post('https://api.srilankaballooning.com/api/addAgent', { AGENT_NAME: name });
            }
            message.success('Agent(s) added');
            agentForm.resetFields();
            fetchData();
        } catch (error) {
            message.error('Failed to add agent(s)');
        }
    };

    const handleDeleteHotel = async (id) => {
        try {
            await axios.post('https://api.srilankaballooning.com/api/deleteHotel', { HOTEL_ID: id });
            message.success('Hotel deleted');
            fetchData();
        } catch (error) {
            message.error('Failed to delete hotel');
        }
    };

    const handleDeleteAgent = async (id) => {
        try {
            await axios.post('https://api.srilankaballooning.com/api/deleteAgent', { AGENT_ID: id });
            message.success('Agent deleted');
            fetchData();
        } catch (error) {
            message.error('Failed to delete agent');
        }
    };

    const hotelColumns = [
        {
            title: 'Hotel Name',
            dataIndex: 'HOTEL_NAME',
            key: 'name'
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Popconfirm
                    title="Delete this hotel?"
                    onConfirm={() => handleDeleteHotel(record.HOTEL_ID)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button danger size="small">Delete</Button>
                </Popconfirm>
            )
        }
    ];

    const agentColumns = [
        {
            title: 'Agent Name',
            dataIndex: 'AGENT_NAME',
            key: 'name'
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Popconfirm
                    title="Delete this agent?"
                    onConfirm={() => handleDeleteAgent(record.AGENT_ID)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button danger size="small">Delete</Button>
                </Popconfirm>
            )
        }
    ];

    return (
        <div style={{ padding: 20 }}>
            <Divider orientation="left">Hotels</Divider>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <Card title="Add Hotels (comma-separated)" bordered>
                        <Form form={hotelForm} onFinish={handleAddHotels} layout="vertical">
                            <Form.Item name="hotel_names" label="Hotel Name(s)" rules={[{ required: true }]}>
                                <Input.TextArea placeholder="e.g. Cinnamon Grand, Galle Face Hotel" />
                            </Form.Item>
                            <Button type="primary" htmlType="submit">Add Hotels</Button>
                        </Form>
                    </Card>
                </Col>
                <Col xs={24} md={12}>
                    <Table
                        dataSource={hotels}
                        columns={hotelColumns}
                        rowKey="HOTEL_ID"
                        loading={loading}
                        pagination={false}
                        size="small"
                    />
                </Col>
            </Row>

            <Divider orientation="left" style={{ marginTop: 40 }}>Agents</Divider>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <Card title="Add Agents (comma-separated)" bordered>
                        <Form form={agentForm} onFinish={handleAddAgents} layout="vertical">
                            <Form.Item name="agent_names" label="Agent Name(s)" rules={[{ required: true }]}>
                                <Input.TextArea placeholder="e.g. John Travels, Holiday Lanka" />
                            </Form.Item>
                            <Button type="primary" htmlType="submit">Add Agents</Button>
                        </Form>
                    </Card>
                </Col>
                <Col xs={24} md={12}>
                    <Table
                        dataSource={agents}
                        columns={agentColumns}
                        rowKey="AGENT_ID"
                        loading={loading}
                        pagination={false}
                        size="small"
                    />
                </Col>
            </Row>
        </div>
    );
};

export default HotelAgentManagement;
